import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Helmet from 'react-helmet';

import Footer from './Footer';
import Menu from './Menu';

import '../fonts/work-sans-local.css';
import '../styles/variables.css';
import './Layout.css';

const Layout = (props) => {
	const { children, title, className } = props;
	const data = useStaticQuery(graphql`
		query SiteTitleQuery {
			site {
				siteMetadata {
					title
				}
			}
		}
	`);

	return (
		<div className={'layout--root'}>
			<Helmet title={title ? `${title} — ${data.site.siteMetadata.title}` : data.site.siteMetadata.title}>
				<html lang="en" />
			</Helmet>
			<Menu siteTitle={data.site.siteMetadata.title} invert={props.invert} />
			{className ? <main className={className}>{children}</main> : <main>{children}</main>}

			<Footer />
		</div>
	);
};

export default Layout;
